import React, { useEffect, useCallback, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import WifiTetheringIcon from '@material-ui/icons/WifiTethering';
import { CircularProgress, Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { isUndefined, isEmpty, isNull } from 'lodash';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import './index.scss';
import EditLiveContent from '../../components/EditLiveContent';
import { uploadContentService } from '../../services';

import { useHistory } from 'react-router-dom';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#252525",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
    color: theme.palette.common.white,
  },
  button: {
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: "#424242",
    },
    '&:nth-of-type(even)': {
      backgroundColor: "#252525",
    },
  },
}))(TableRow);

function createData(SPILLELISTER, BUTTON) {
  return { SPILLELISTER, BUTTON };
}

const useStyles = makeStyles({
  table: {
    maxWidth: 2000,

  },
  button: {
    marginTop: 10,
    height: 40,
    width: 80,
    float: 'right',
    fontSize: 15,
    fontWeight: 'bold',
    color: '#ffffff',
    backgroundColor: '#6C6C6C'
  },
  buttonShowDevices: {
    marginTop: 10,
    height: 40,
    width: 230,
    float: 'right',
    fontSize: 13,
    fontWeight: 'bold',
    color: '#ffffff',
    backgroundColor: '#0486C8',
    marginRight: '10px'
  },
  cellGreen: {
    backgroundColor: 'green',
    width: "50%",
    marginTop: '10px',
    // minHeight: 15,
    // margin: 5,
  },
  cellRed: {
    backgroundColor: 'red',
    width: '50%',
    marginTop: '10px',
  },
});

export default function CustomizedTables() {
  const classes = useStyles();
  const history = useHistory();

  const [dynamicPlaylists, setDynamicPlaylists] = useState([]);
  const { user } = useSelector(state => state.userAuthentication);

  const [openUnit1, setOpenUnit1] = useState(false);
  const [expandItemNumber, setExpandItemNumber] = useState(null);

  const handleOpenUnit1 = (event) => {
    const index = parseInt(event.currentTarget.dataset.index);
    if (index === expandItemNumber) {
      setExpandItemNumber(index);
      setOpenUnit1(!openUnit1);
    }
    else {
      // setOpenUnit1(!openUnit1);
      setExpandItemNumber(index);
      setOpenUnit1(true);
    }
  };

  const handleRedirectToPage = (event) => {
    if (event.currentTarget.dataset.value === "playlist") {
      history.push({
        pathname: '/playlist',
        state: { id: event.currentTarget.dataset.id }
      });
      window.location.reload();
    }
  }

  const getDynamicPlaylists = useCallback(async (devices) => {
    if (!isUndefined(user)) {
      const res = await uploadContentService.uploadContentPlaylist(user);
      if (res?.items.length > 0) {
        crossmatchDevicePlaylist(devices, res?.items);
      }
    }
  }, [user]);

  const getTaggedContentUnitList = async () => {
    if (!isUndefined(user)) {
      const marker = '';
      var devices = [];
      const recursiveFunc = async (marker) => {
        var res = await uploadContentService.taggedContentUnitList(user, marker);
        if (!isUndefined(res)) {
          if (!isUndefined(res?.devices)) {
            devices.push.apply(devices, res?.devices);
          }
          if (res.isTruncated) {
            await recursiveFunc(res.nextMarker);
          }
        }
      }
      await recursiveFunc(marker);
      return devices;
    }
  }

  const crossmatchDevicePlaylist = (devices, playlist) => {
    let newPlaylist = playlist;
    [...playlist].map((itemPlaylist, indexPlaylist) => {
      let newDevices = [];
      [...devices].map((itemDevice, indexDevice) => {
        let indexPresentationCheck = -1;
        if (!isNull(itemDevice.presentation))
          indexPresentationCheck = itemPlaylist.presentations.findIndex(x => x.id === itemDevice.presentation.id);
        if (indexPresentationCheck === -1 || itemPlaylist.presentations.length === 0)
          itemDevice.isMatch = false;
        else
          itemDevice.isMatch = true;

        newDevices.push({
          id: itemDevice.id,
          name: itemDevice.name,
          isMatch: itemDevice.isMatch
        });
      })
      if (newPlaylist[indexPlaylist].devices === undefined) {
        newPlaylist[indexPlaylist].devices = newDevices;
        setDynamicPlaylists(newPlaylist);
      }
    })
  }

  useEffect(async () => {
    let devices = await getTaggedContentUnitList();
    getDynamicPlaylists(devices);
  }, [user]);

  return (
    <div>
      <span className="span-design">
        <div className="icon-design"><WifiTetheringIcon /> LIVE </div>
        <h3 className="text-design">  CONTENT - HQ</h3>
      </span>
      <TableContainer component={Paper} className={classes.table}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="left">SPILLELISTER</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!isUndefined(dynamicPlaylists) ? (
              [...dynamicPlaylists].map((item, index) => (
                <StyledTableRow key={item.name} >
                  <StyledTableCell align="left" component="th" scope="row">
                    <List component="nav" aria-labelledby="nested-list-subheader">
                      {item.name}

                      <Button
                        onClick={handleRedirectToPage}
                        variant="contained"
                        startIcon={<EditIcon />}
                        data-value="playlist"
                        data-id={item.id}
                        className={classes.button}
                      >
                        RET
                      </Button>
                      <Button
                        variant="contained"
                        data-index={index} onClick={handleOpenUnit1}
                        className={classes.buttonShowDevices}
                      >
                        {expandItemNumber === index && openUnit1 ? 'Hide relation with devices' : 'Show relation with devices'}
                      </Button>

                      {
                        !isUndefined(item.devices) &&
                        <div style={{ marginTop: '30px' }}>
                          {
                            item.devices.map((itemDevices, indexDevices) => (
                              <Collapse in={expandItemNumber === index ? openUnit1 : false} timeout="auto" unmountOnExit>
                                <Grid container>
                                  <Grid xs={6}>
                                    <List component="div" disablePadding>
                                      <ListItem className={classes.nested} style={{ marginTop: indexDevices === 0 ? '20px' : '10px' }}>
                                        <ListItemIcon className={classes.listItemIcon}>
                                          <VideoLabelIcon />
                                        </ListItemIcon>
                                        <ListItemText primary={itemDevices.name} />
                                      </ListItem>
                                    </List>
                                  </Grid>
                                  <Grid xs={6}>
                                    <List className={itemDevices.isMatch === true ? classes.cellGreen : classes.cellRed}
                                      component="div" disablePadding
                                      style={{ marginTop: indexDevices === 0 ? '20px' : '13px' }}>
                                      <ListItem className={classes.nested}>
                                        <ListItemText primary="" />
                                      </ListItem>
                                    </List>
                                  </Grid>
                                </Grid>
                              </Collapse>
                            ))
                          }
                        </div>
                      }
                    </List>
                  </StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <div className="loader">
                <CircularProgress />
              </div>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div >
  );
}